import {
  FETCH_CUSTOMER_CONSOLIDATED_REPORT_REQUEST,
  FETCH_CUSTOMER_CONSOLIDATED_REPORT_SUCCESS,
  FETCH_CUSTOMER_CONSOLIDATED_REPORT_FAIL,
  CUSTOMER_LIST_REQUEST,
  CUSTOMER_LIST_SUCCESS,
  CUSTOMER_LIST_FAIL,
  CUSTOMER_TYPE_REQUEST,
  CUSTOMER_TYPE_SUCCESS,
  CUSTOMER_TYPE_FAIL,
    KARNATAKA_CITIES_REQUEST,
  KARNATAKA_CITIES_SUCCESS,
  KARNATAKA_CITIES_FAIL,
} from "../actionTypes";

const initialState = {
  consolidatedReport: null,
  reportLoading: false,
  reportError: null,
  customers: [],
  customerTypes: [],
    karnatakaCities: [],
  loading: false,
  error: null,
};

export const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_CONSOLIDATED_REPORT_REQUEST:
      return {
        ...state,
        reportLoading: true,
        reportError: null,
      };

    case FETCH_CUSTOMER_CONSOLIDATED_REPORT_SUCCESS:
      return {
        ...state,
        reportLoading: false,
        consolidatedReport: action.payload,
        reportError: null,
      };

    case FETCH_CUSTOMER_CONSOLIDATED_REPORT_FAIL:
      return {
        ...state,
        reportLoading: false,
        reportError: action.payload,
      };

    case CUSTOMER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: action.payload || [],
        error: null,
      };

    case CUSTOMER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
 case KARNATAKA_CITIES_REQUEST:
      return {
        ...state,
        citiesLoading: true,
        citiesError: null,
      };

    case KARNATAKA_CITIES_SUCCESS:
      return {
        ...state,
        citiesLoading: false,
        karnatakaCities: Array.isArray(action.payload) ? action.payload : [],
        citiesError: null,
      };

    case KARNATAKA_CITIES_FAIL:
      return {
        ...state,
        citiesLoading: false,
        citiesError: action.payload,
      };
    case CUSTOMER_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        customerTypes: Array.isArray(action.payload) ? action.payload : [],
        error: null,
      };

    case CUSTOMER_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default customerReducer;
